module.exports = "<div class=\"application-section\">\n        <app-window\n                v-for=\"app in apps\"\n                :app=\"app\"\n        ></app-window>\n    </div>";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/application.vue
 ** module id = 89
 ** module chunks = 0
 **/